import { DesktopNavigation } from "./DesktopNavigation";
import { MobileNavigation } from "./MobileNavigation";
import { NavigationProps } from "./NavigationProps";

export const Navigation = (props: NavigationProps) => (
  <div className="relative z-40">
    <div className="hidden dsk:block">
      <DesktopNavigation {...props} />
    </div>
    <div className="dsk:hidden">
      <MobileNavigation {...props} />
    </div>
  </div>
);
